import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Grid from '../../common/components/Grid'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField'
import {CircularProgress} from 'material-ui/Progress'

const styles = theme => ({
  textField: {
    width: '100%',
    marginTop: theme.spacing.unit / 2,
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  buttonWrapper: {
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

class StepAddress extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  render() {
    const {classes} = this.props

    return (
      <div>
        <Typography>Ingresá tu domicilio principal.</Typography>
        <Grid container justify="space-between">
          <Grid item xs={12}>
            <TextField
              id="domicilio"
              label="Domicilio"
              className={classes.textField}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              id="piso"
              label="Piso y departamento"
              className={classes.textField}
            />
          </Grid>
        </Grid>
        <div className={classes.actionsContainer}>
          <Grid container justify="space-between">
            <Grid item>
              <Button
                disabled={false}
                onClick={this.props.handleBackButtonClick}
                className={classes.button}
              >
                Atrás
              </Button>
            </Grid>
            <Grid item>
              <div className={classes.buttonWrapper}>
                <Button
                  variant="raised"
                  color="primary"
                  disabled={this.props.loading}
                  onClick={this.props.handleNextButtonClick}
                >
                  Finalizar
                </Button>
                {this.props.loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }

}

StepAddress.propTypes = {
  handleNextButtonClick: PropTypes.func.isRequired,
  handleBackButtonClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
}

export default withStyles(styles, {withTheme: true})(StepAddress)



// WEBPACK FOOTER //
// ./src/sections/firstlogin/StepAddress.js